'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactFontawesome = require('@fortawesome/react-fontawesome');
var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
var _faBars = require('@fortawesome/fontawesome-free-solid/faBars');
var _faBars2 = _interopRequireDefault(_faBars);
var _faTimes = require('@fortawesome/fontawesome-free-solid/faTimes');
var _faTimes2 = _interopRequireDefault(_faTimes);
var _Nav = require('./Nav');
var _Nav2 = _interopRequireDefault(_Nav);
var _Logo = require('./Logo');
var _Logo2 = _interopRequireDefault(_Logo);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Header = function (_React$Component) {
  _inherits(Header, _React$Component);
  function Header() {
    _classCallCheck(this, Header);
    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this));
    _this.state = {
      expanded: false
    };
    _this.expandNav = _this.expandNav.bind(_this);
    return _this;
  }
  _createClass(Header, [{
    key: 'expandNav',
    value: function expandNav() {
      var expanded = !this.state.expanded;
      this.setState({
        expanded: expanded
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var logo = void 0;
      if (this.props.logo) {
        logo = _react2.default.createElement(_Logo2.default, {
          className: 'header__logo',
          src: this.props.logo,
          onLogoClick: this.props.onLogoClick
        });
      }
      var headerElements = void 0;
      if (this.props.children) {
        headerElements = _react2.default.createElement('div', null, this.props.children);
      } else {
        headerElements = _react2.default.createElement('div', null, logo, _react2.default.createElement('button', {
          className: 'nav-toggle',
          onClick: this.expandNav,
          type: 'button',
          'aria-expanded': this.state.expanded,
          'aria-label': 'Toggle navigation'
        }, _react2.default.createElement(_reactFontawesome2.default, {
          className: 'nav-toggle__icon',
          icon: this.state.expanded ? _faTimes2.default : _faBars2.default
        })), _react2.default.createElement(_Nav2.default, {
          links: this.props.links,
          expanded: this.state.expanded
        }));
      }
      return _react2.default.createElement('header', {
        className: 'header ' + this.props.className
      }, headerElements);
    }
  }]);
  return Header;
}(_react2.default.Component);
Header.defaultProps = {
  className: '',
  children: null,
  logo: '',
  links: [{
    title: 'Products',
    url: '/products'
  }, {
    title: 'Recipes',
    url: '/recipes'
  }],
  onLogoClick: function onLogoClick() {
    return false;
  }
};
Header.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.oneOf([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  logo: _propTypes2.default.string,
  links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    className: _propTypes2.default.string,
    image: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    title: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string
  })),
  onLogoClick: _propTypes2.default.func
};
exports.default = Header;